<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="学员状态">
        <Select v-model="searchCondition.status" style="width: 200px" clearable>
          <Option value="0">禁用</Option>
          <Option value="1">启用</Option>
        </Select>
      </Form-item>
      <Form-item label="学员昵称">
        <Input
          style="width: 200px"
          placeholder="请输入学员昵称"
          v-model="searchCondition.nickname"
          clearable
        />
      </Form-item>
      <Form-item label="手机号">
        <Input
          style="width: 200px"
          placeholder="请输入学员手机号"
          v-model="searchCondition.mobile"
          clearable
        />
      </Form-item>

      <Form-item label="课程名称">
        <Input
          style="width: 200px"
          placeholder="请输入购买过的课程名称"
          v-model="searchCondition.course_name"
          clearable
        />
      </Form-item>

      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        :data-url="dataUrl"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        :selectedItems="selectedItems"
        keyField="uid"
        keepSelected
      ></Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "StudentSelect",
  props: {
    selectedItems: {
      type: Array,
    },
    selectType: {
      type: String,
      default: "multi",
    },
    dataUrl: {
      type: String,
      default: "/api/user",
    },
  },
  data() {
    return {
      column: [
        {
          title: "昵称",
          key: "nickname",
        },
        {
          title: "手机号",
          key: "mobile",
          width: 180,
          align: "center",
        },
        {
          title: "状态",
          key: "status_caption",
          width: 100,
          align: "center",
        },
      ],
      selectList: [],
      searchCondition: {
        status: "",
        nickname: "",
        mobile: "",
        course_name: "",
        init: function () {
          this.status = "";
          this.nickname = "";
          this.mobile = "";
          this.course_classify_id = "";
        },
      },
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach((row) => {
        row.status_caption = row.status == 0 ? "禁用" : "启用";
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
        this.$refs.grid.searchRefresh();
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    },
  },
};
</script>
<style lang="scss" scoped></style>
